import { Team } from "./types";

export const getAllTeams = (): Team[] => Object.values(Team);

export const getTeamLabel = (team: Team): string => {
  switch (team) {
    case Team.CORE:
      return "Core";
    case Team.CREATOR:
      return "Creator";
    case Team.INTEGRATEX:
      return "IntegrateX";
    case Team.INTEGRATION:
      return "Integration";
    case Team.PLATFORM:
      return "Platform";
    case Team.PRODUCTFACTORY:
      return "Product Factory";
    case Team.REACTOR:
      return "Reactor";
    case Team.SAXONEERS:
      return "Saxoneers";
    case Team.UX:
      return "UX";
    case Team.WEBDEV:
      return "WebDev";
    case Team.OTHER:
      return "Other";
    default: {
      const unhandledTeam: never = team;
      throw new Error(`Unknown team: ${String(unhandledTeam)}`);
    }
  }
};
